import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import Layout from "../../Layout";

import CustomHeaderTitle from "../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../components/HeaderBread";
import Logs from "../../components/Logs";
import SwitchBar from "../../components/Pages/SwitchBar";
import CustomizedTable from "../../components/UI/CustomizedTable";
import {
  deleteSailingCurrency,
  getSailingCurrency,
  updateSailingCurrency,
} from "../../utils/ApiCalls/SailingDates";
import ActiveSwitchFile from "../../components/SwitchFile";
import DeletePop from "../../constants/ErrorPermissionModal";
import { checkPermission } from "../../utils/Validation/checkPermission";
import { message } from "antd";
import Swal from "sweetalert2";
import { deleteVenueMaster } from "../../utils/ApiCalls/Mobile/VenueMaster";
import { addlog } from "../../utils/ApiCalls/Logs";
import CurrencyTable from "./CurrencyTable";
import { LOG_ACTIONS, LOG_TYPES } from "../../utils/Constant/LogConstant";


const SailingDate = () => {
  const navigate = useNavigate();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Currency",
      route: "/website/cms/promo-index",
    },
  ];
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState("listing");
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();
  const [promoIndexs, setPromoIndexs] = useState([]);
  const [promoIndex, setPromoIndex] = useState("");

  const location = useLocation();

  const [page, setPage] = useState(
    () => parseInt(new URLSearchParams(location.search).get("page")) || 1
  );
  const [pageSize, setPageSize] = useState(
    () => parseInt(new URLSearchParams(location.search).get("pageSize")) || 10
  );
  const [search, setSearch] = useState(
    () => new URLSearchParams(location.search).get("search") || ""
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageParam = parseInt(params.get("page")) || 1;
    const pageSizeParam = parseInt(params.get("pageSize")) || 10;
    const searchParam = params.get("search") || "";

    // setPage(pageParam);
    // setPageSize(pageSizeParam);
    setSearch(searchParam);
  }, [location.search]);

  useEffect(() => {
    const params = new URLSearchParams();
    const currentParams = new URLSearchParams(location.search);

    params.set("page", page);
    params.set("pageSize", pageSize);
    if (search) params.set("search", search);

    if (currentParams.toString() !== params.toString()) {
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [page, pageSize, search, navigate, location.search]);

  useEffect(() => {
    getData(page);
  }, [page, pageSize]);

  const handleEdit = async (id) => {
    if (checkPermission(permission, "update_per", "Currency", window?.location?.pathname)) {
      navigate("/shore/mobile-masters/sailing_currency/edit/" + id);
    } else {
      message.error("Update permission missing");
    }
  };
  
  const handleDelete = async (id,currency_name,vessel_name) => {
    if (checkPermission(permission, "delete_per", "Currency", window?.location?.pathname)) {
      await deleteSailingCurrency(id);
      await getData(page);
      addlog(
        LOG_ACTIONS.REMOVED,
        LOG_TYPES.Currency, { id,title: `${currency_name} Currency Deleted for ${vessel_name} Vessel` }, userDetails.id);
    } else {
      message.error("Missing Permission for delete");
    }
  };

  const handleUpdate = async (id, values, title, location_id,record) => {
    if (checkPermission(permission, "update_per", "Currency", window?.location?.pathname)) {
      let data = await updateSailingCurrency(id, values);
      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.error,
        });
      } else {
         addlog(
          `${(!values.valid_from
            ? values.is_active === 1
              ? LOG_ACTIONS.ACTIVATED
              : LOG_ACTIONS.DEACTIVATED
            : LOG_ACTIONS.UPDATED)}`,
          LOG_TYPES.Currency,
          { ...values, id, title : `${title} ${LOG_TYPES.Currency}, ${record.vessel.name} Vessel`,location_id },
          userDetails.id
        );
      }
      getData(page);
    } else {
      message.error("Update permission missing");
    }
  };
  const getData = async (value) => {
    let args = { page: value, limit: 1000 };
    if (promoIndex) {
      args = { ...args, promoIndex };
    }
    let data = await getSailingCurrency(args);
    if (data.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    } else if (data.data) {
      setRows(data.data);
      setCount(data.count);
      // if (data?.promoIndex) {
      //   data.promoIndex.unshift({ promo_index: "All" });
      //   setPromoIndexs(data.promoIndex);
      // }
    }
  };

  return (
    <Layout type={"read_per"} module_data={"Currency"}>
      <CustomHeaderTitle title={"Currency"} />
      <div>
        <div>
          <HeaderBread navigation={navigation} title={"Currency"}></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <SwitchBar
              tabs={[
                { title: "Currency", value: "listing" },
                { value: "logs", title: " History Logs" },
              ]}
              activeTab={active}
              setActiveTab={setActive}
            />
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">Currency List</h5>
                  <div className="two_item">
                    <Link
                      to="/shore/mobile-masters/sailing_currency/add"
                      className="btn add_v_btn mx-2"
                    >
                      Add Currency
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table_holder">
                    {rows?.length > 0 && (
                      <CurrencyTable
                        onDelete={handleDelete}
                        onEdit={handleEdit}
                        handleUpdate={handleUpdate}
                        rows={rows}
                      />
                    )}
                    {/* <CustomizedTable
                      setRows={setRows}
                      setPageSize={setPageSize}
                      setPage={setPage}
                      pageSize={pageSize}
                      page={page}
                      count={count}
                      columns={columns}
                      rows={rows}
                      title={"Currency"}
                    /> */}
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        {active === "logs" && (
          <Logs
            type={"Currency"}
            slug={"/website/cms/packages/edit/"}
            refreshlog={active}
          />
        )}
      </div>
    </Layout>
  );
};

export default SailingDate;
